export const FormRegistrationPhoneNumberTranslationsEn = {
  phoneNumberLabel: 'Phone Number',
  phoneNumberPlaceholder: '+420',
  phoneNumberErrorMessage: 'Please enter a valid phone number',
  passwordLabel: 'Password',
  passwordPlaceholder: '****',
  passwordErrorMessage: 'Please enter a valid password',
  privacyPolicyText: 'By clicking Register, you accept',
  privacyPolicyLinkText: 'Privacy Policy',
  registerButton: 'Register',

  // error
  'Required field': 'Required field',
  'Invalid phone number format': 'Invalid phone number format',
  'Password must be at least 8 characters':
    'Password must be at least 8 characters',
  'Password must be less than 32 characters':
    'Password must be less than 32 characters',
  'Password must contain at least 8 Latin characters, one uppercase letter, one digit':
    'Password must contain at least 8 Latin characters, one uppercase letter, one digit',

  // errors back-end
  'Phone number in use': 'Phone number in use',
};
